import React, { useContext } from 'react';
import EDIconButton from '../../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import EDButton from '../../../../../../../BaseComponents/Buttons/Button/EDButton';
import EDIcon from '../../../../../../../BaseComponents/Icon/EDIcon';
import FakturaDelContext from '../FakturaDelContextManager/FakturaDelContext';
import { TEDLRFakturaAttestAttestTypEnum } from '../../../../../../../globalQueryTypes';
import {
  useIsMediumBreakpoint,
  useIsSmallBreakpoint,
} from '../../../../../../../Components/BreakpointContext/BreakpointContextUtils';

interface IProps {
  onClick: () => void;
}

const HandleCertifiersButton: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const fakturaDelContext = useContext(FakturaDelContext);
  const isSmall = useIsSmallBreakpoint();
  const isMedium = useIsMediumBreakpoint();

  const attesterar = !fakturaDelContext.jagAttesterar;

  const notControlCertifier =
    fakturaDelContext.minFakturaAttest.aktuellFakturaAttest?.AttestTyp !==
    TEDLRFakturaAttestAttestTypEnum.KONTROLLATTEST;

  return isSmall ? (
    <EDIconButton
      color="primary"
      disabled={attesterar || !notControlCertifier}
      icon="person"
      margin="none"
      onClick={props.onClick}
      padding="dense"
      tooltip="Hantera Attestanter"
      testId="hanteraAttestant"
    />
  ) : isMedium ? (
    <EDButton
      color="primary"
      disabled={attesterar || !notControlCertifier}
      tooltip="Hantera Attestanter"
      flat
      onClick={props.onClick}
      size="medium"
      icon={
        <EDIcon
          color={attesterar || !notControlCertifier ? 'disabled' : 'primary'}
          iconType="person"
        />
      }
      testId="hanteraAttestant"
    >
      <span style={{ lineHeight: 1 }}>Hantera Attestanter</span>
    </EDButton>
  ) : (
    <EDButton
      color="primary"
      disabled={attesterar || !notControlCertifier}
      flat
      tooltip="Hantera Attestanter"
      onClick={props.onClick}
      size="medium"
      icon={
        <EDIcon
          color={attesterar || !notControlCertifier ? 'disabled' : 'primary'}
          iconType="person"
        />
      }
      testId="hanteraAttestant"
    >
      <span style={{ lineHeight: 1 }}>Hantera Attestanter</span>
    </EDButton>
  );
};

export default HandleCertifiersButton;
